export const required_error = 'Campo obrigatório';

export const positive_value_error = 'O valor deve ser positivo';

export default {
  required_error,
  positive_value_error,
};
